/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierDeliveryNotesArrayV3 } from '../../models/carrier-delivery-notes-array-v-3';
import { DeliveryNotesFilterProperties } from '../../models/delivery-notes-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetCarrierDeliveryNotesV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by
 */
  sortBy?: 'dateCreated' | 'checkoutDate' | 'checkinDate' | 'dateAnnounced' | 'tourNumber' | 'number' | 'orderNumber' | 'deliveryNoteBundleNumber' | 'deliveryNoteBundleStatus' | 'consignorName' | 'carrierName' | 'consigneeName' | 'carrierNumberPlateOutgoing' | 'carrierNumberPlateIncoming' | 'consignorLoadCarrierExchange' | 'originalConsignor' | 'originalConsignorGln' | 'discrepancies' | 'palletTickets' | 'properties' | 'properties.referenceNumber';

/**
 * Array of organization site keys to fetch data from (max 10). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Field to filter carrier delivery notes by
 */
  filterProperty?: DeliveryNotesFilterProperties;

/**
 * Value to filter by (partial match)
 */
  filterValue?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;

/**
 * If true, only return bundles where at least one delivery note has a discrepancy (normal or fine). Uses the bundle.discrepancies flag for efficient filtering.
 */
  filterOnlyDiscrepancies?: boolean;
}

export function getCarrierDeliveryNotesV3(http: HttpClient, rootUrl: string, params: GetCarrierDeliveryNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNotesArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getCarrierDeliveryNotesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
    rb.query('filterOnlyDiscrepancies', params.filterOnlyDiscrepancies, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarrierDeliveryNotesArrayV3>;
    })
  );
}

getCarrierDeliveryNotesV3.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes';
